import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { forkJoin, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { SessionService } from '../../common/services/Session.service';
@Component({
  selector: 'app-master-glossary',
  templateUrl: './master-glossary.component.html',
  styleUrls: ['./master-glossary.component.css']
})
export class MasterGlossaryComponent implements OnInit {


  contactsOnAlphaClick: any = [];
  contacts: any = [];
  codContacts: any = [];
  opContacts: any = [];
  cigContacts: any = [];
  /*isBasicUser: boolean = false;*/
  result: any;
  codificationResult: any;
  alphabetsArray: any[][];
  alphabetArray: string[];
  filter: string = "";
  originalDataSet: any;
  selectedAlphabet: string = "";
  apiResponse: any;
  title: string = "";
  body: any = "";
  codification: boolean = false;
  originalPronouncements: boolean = false;
  comprehensiveImplementationGuide: boolean = false;
  GlossaryColumnlabels: any = [];
  leftNavmenuLevel = [1, 2, 3];
  outcome: boolean = false;
  category: number = 0;
  availableAlphabets = [];

  private glossaryterm$ = new Subject<string>();

  constructor(
    private graphQlService: GraphqlService,
    public commonDataService: CommonDataService, private route: Router,
    public loginService: LoginService, private session: SessionService, private domsanitizer: DomSanitizer) {
    this.alphabetsArray = [["0-9", "A", "B", "C"], ["D", "E", "F", "G"], ["H", "I", "J", "K"], ["L", "M", "N", "O"], ["P", "Q", "R", "S"], ["T", "U", "V", "W"], ["X", "Y", "Z"]]
    this.alphabetArray = ["0-9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
  }

  ngOnInit() {
    this.commonDataService.showLoader.next(true);
    this.glossaryterm$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((filtervalue) => {
      this.onChangeText(filtervalue);
    });
    if (!this.LoadMasterGlossaryFromContentPageBackButton()) {
      this.invokeGlossaryContent(true);
    }
    //if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
    //  this.loginService.getSession().subscribe(data => {
    //    if (data.user.roles == "Basic") {
    //      this.isBasicUser = true;
    //    }
    //    this.session.assignSession(data);
    //  })
    //}
    //else {
    //  if (this.session.userInfo.user.roles == "Basic") { this.isBasicUser = true; }
    //}
    this.graphQlService.getCurrentVersionLeftNavigation().subscribe(data => {
    //this.graphQlService.getLeftNavigation().subscribe(data => {
      // this.GlossaryColumnlabels = data.filter((el, i) => this.leftNavmenuLevel.some(j => i === j)).map(y => y.item);

      var tabHeading = data.filter((el, i) => this.leftNavmenuLevel.some(j => i === j)).map(y => y.item);
      tabHeading.forEach(columnLabels => {
        if (columnLabels.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()) || columnLabels.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()) || columnLabels.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase())) {
          this.GlossaryColumnlabels.push(columnLabels);
        }
      })
      if (this.GlossaryColumnlabels.length != 3) {
        if (!this.GlossaryColumnlabels.some(x => x.toLocaleLowerCase().includes(("Codification").toLocaleLowerCase()))) {
          this.GlossaryColumnlabels.push("Codification");
        }
        if (!this.GlossaryColumnlabels.some(x => x.toLocaleLowerCase().includes(("Original Pronouncements").toLocaleLowerCase()))) {
          this.GlossaryColumnlabels.push("Original Pronouncements");
        }
        if (!this.GlossaryColumnlabels.some(x => x.toLocaleLowerCase().includes(("Comprehensive Implementation Guide").toLocaleLowerCase()))) {
          this.GlossaryColumnlabels.push("Comprehensive Implementation Guide");
        }
      }

    })

    this.graphQlService.getGlobalLabels().subscribe(globalLabels => {
      //if (!this.LoadMasterGlossaryFromContentPageBackButton()) {
      this.getAlphabetsList();
      //}
      this.getGlossaryLabel(globalLabels);
      this.outcome = true;
      this.codification = true;
      this.commonDataService.showLoader.next(false);
    });
  }
  applyFilter(filterValue: string) {
    this.glossaryterm$.next(filterValue);
  }
  ngAfterContentChecked() {
    this.EnableBackToTop();
  }

  masterGlossaryHeader: string = "";
  GlossaryTermFinderHeader: string = "";
  FilterLabel: string = "";
  PlaceholderLabel: string = "";
  noFoundHeader: string = "";
  noFoundDescription: string = "";
  resetButton: string = "";
  glossaryTermUsage: string = "";
  seeTopics: string = "";
  noLinks: string = "";
  showNoCodResults: boolean = false;
  showNoOpResults: boolean = false;
  showNoCigResults: boolean = false;
  codGlossaryContent = [];
  cigGlossaryContent = [];
  opGlossaryContent = [];

  codGlossaryContentCount: number = 0;
  cigGlossaryContentCount: number = 0;
  opGlossaryContentCount: number = 0;

  CodPageCount: number = 0;
  OpPageCount: number = 0;
  CigPageCount: number = 0;

  resetAlphabet: string = "";

  getGlossaryLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.masterGlossaryHeader = labels.filter(x => x.key == "glossary_header").map(y => y.value);
      this.FilterLabel = labels.filter(x => x.key == "glossary_filter").map(y => y.value);
      this.PlaceholderLabel = labels.filter(x => x.key == "glossary_enterTerm").map(y => y.value);
      this.noFoundHeader = labels.filter(x => x.key == "glossary_noResultFound").map(y => y.value);
      this.noFoundDescription = labels.filter(x => x.key == "glossary_noResultFoundMessage").map(y => y.value);
      this.glossaryTermUsage = labels.filter(x => x.key == "glossary_termUsage").map(y => y.value);
      this.noLinks = labels.filter(x => x.key == "noIncomingLink").map(y => y.value);
      this.seeTopics = labels.filter(x => x.key == "glossary_see").map(y => y.value);
      this.resetButton = labels.filter(x => x.key == "glossary_Reset").map(y => y.value);
      this.GlossaryTermFinderHeader = labels.filter(x => x.key == "glossary_term_finder").map(y => y.value);
      this.resetAlphabet = labels.filter(x => x.key == "glossary_resetAlphabet").map(y => y.value);
    }
  }

  LoadMasterGlossaryFromContentPageBackButton() {
    var isButtonClicked = this.commonDataService.glossaryTermBackButtonClicked.getValue();
    if (isButtonClicked) {
      this.commonDataService.glossaryTermBackButtonClicked.next(false);
      this.invokeGlossaryContent(false);
    }

    return isButtonClicked;
  }

  topic;
  NextPageData = [];
  formattedGlossaryTitle: any = "";
  mapGlossaryContent(data, glossaryType?: string) {
    this.NextPageData = [];
    this.apiResponse = data;
    this.apiResponse.forEach(res => {
      this.topic = [];
      let source = res.source;
      let sourceTitle = source.title;
      this.title = source.title == null ? "NA" : source.title;
      let breadcrumbPath = source.levelThree == source.title ? "" : source.levelThree.startsWith(source.levelTwo) ? " ( " + source.levelThree?.split("-")[1] + " )" : " ( " + source.levelThree + " )";
      breadcrumbPath = "<span class='overlay-bread-crumb'>&nbsp;" + breadcrumbPath + "</span>";
      this.title = this.title != "NA" ? this.title + breadcrumbPath : this.title;
      this.formattedGlossaryTitle = source.formattedGlossaryTitle == null ? this.title : source.formattedGlossaryTitle + breadcrumbPath;
      // this.body = source.body;
      this.body = this.domsanitizer.bypassSecurityTrustHtml(source.body);
      if (source.usage != null) {
        source.usage.forEach(usage => {
          this.topic.push(usage)
        });
      }
      var content = { name: this.title, formattedGlossaryTitle: this.formattedGlossaryTitle, capital: this.body, topic: this.topic, sourceName: sourceTitle };
      this.contacts.push(content);
    });
    this.contacts.sort((a, b) => (a.sourceName.toLowerCase() < b.sourceName.toLowerCase() ? -1 : 1));
    this.originalDataSet = this.contacts;
    if (glossaryType == "glossary_codification") {
      if (this.CodPageCount == 0) {
        this.result = this.createResultFromContact(this.contacts);
      }
      else {
        this.NextPageData = this.createResultFromContact(this.contacts);
        if (this.NextPageData.length != 0) {
          this.NextPageData.forEach(NewData => {
            var concatContact = this.codGlossaryContent.find(x => x.key == NewData.key);
            if (concatContact) {
              this.codGlossaryContent.find(x => x.key == NewData.key).contacts = concatContact.contacts.concat(NewData.contacts);
            }
            else {
              this.codGlossaryContent.push(NewData)
            }
          });
        }
        this.codGlossaryContent.sort((a, b) => (a.key.toLowerCase() < b.key.toLowerCase() ? -1 : 1));
        this.codGlossaryContentCount = this.codGlossaryContentCount + this.contacts.length;
        this.result = this.codGlossaryContent;
      }
    }
    else if (glossaryType == "glossary_op") {
      if (this.OpPageCount == 0) {
        this.result = this.createResultFromContact(this.contacts);
      }
      else {
        this.NextPageData = this.createResultFromContact(this.contacts);
        if (this.NextPageData.length != 0) {
          this.NextPageData.forEach(NewData => {
            var concatContact = this.opGlossaryContent.find(x => x.key == NewData.key);
            if (concatContact) {
              this.opGlossaryContent.find(x => x.key == NewData.key).contacts = concatContact.contacts.concat(NewData.contacts);
            }
            else {
              this.opGlossaryContent.push(NewData)
            }
          });
        }
        this.opGlossaryContent.sort((a, b) => (a.key.toLowerCase() < b.key.toLowerCase() ? -1 : 1));
        this.opGlossaryContentCount = this.opGlossaryContentCount + this.contacts.length;
        this.result = this.opGlossaryContent;
      }
    }
    else {
      if (this.CigPageCount == 0) {
        this.result = this.createResultFromContact(this.contacts);
      }
      else {
        this.NextPageData = this.createResultFromContact(this.contacts);
        if (this.NextPageData.length != 0) {
          this.NextPageData.forEach(NewData => {
            var concatContact = this.cigGlossaryContent.find(x => x.key == NewData.key);
            if (concatContact) {
              this.cigGlossaryContent.find(x => x.key == NewData.key).contacts = concatContact.contacts.concat(NewData.contacts);
            }
            else {
              this.cigGlossaryContent.push(NewData)
            }
          });
        }
        this.cigGlossaryContent.sort((a, b) => (a.key.toLowerCase() < b.key.toLowerCase() ? -1 : 1));
        this.cigGlossaryContentCount = this.cigGlossaryContentCount + this.contacts.length;
        this.result = this.cigGlossaryContent;
      }
    }
    return this.result;
  }

  availableAlphabetsList: any = [];
  tempavailableAlphabetsList: any = [];
  getAlphabetsList() {
    if (this.filter == "") {
      this.graphQlService.getGlossaryAlphabetList().subscribe(alphabetsList => {
        this.availableAlphabetsList = this.setAlphabetList(alphabetsList.aggregations);
        this.tempavailableAlphabetsList = this.availableAlphabetsList;
      })
    }
  }

  setAlphabetList(aggregation) {
    this.availableAlphabets = [];
    if (aggregation.a_Count.docCount > 0) { this.availableAlphabets.push("A") }
    if (aggregation.b_Count.docCount > 0) { this.availableAlphabets.push("B") }
    if (aggregation.c_Count.docCount > 0) { this.availableAlphabets.push("C") }
    if (aggregation.d_Count.docCount > 0) { this.availableAlphabets.push("D") }
    if (aggregation.e_Count.docCount > 0) { this.availableAlphabets.push("E") }
    if (aggregation.f_Count.docCount > 0) { this.availableAlphabets.push("F") }
    if (aggregation.g_Count.docCount > 0) { this.availableAlphabets.push("G") }
    if (aggregation.h_Count.docCount > 0) { this.availableAlphabets.push("H") }
    if (aggregation.i_Count.docCount > 0) { this.availableAlphabets.push("I") }
    if (aggregation.j_Count.docCount > 0) { this.availableAlphabets.push("J") }
    if (aggregation.k_Count.docCount > 0) { this.availableAlphabets.push("K") }
    if (aggregation.l_Count.docCount > 0) { this.availableAlphabets.push("L") }
    if (aggregation.m_Count.docCount > 0) { this.availableAlphabets.push("M") }
    if (aggregation.n_Count.docCount > 0) { this.availableAlphabets.push("N") }
    if (aggregation.o_Count.docCount > 0) { this.availableAlphabets.push("O") }
    if (aggregation.p_Count.docCount > 0) { this.availableAlphabets.push("P") }
    if (aggregation.q_Count.docCount > 0) { this.availableAlphabets.push("Q") }
    if (aggregation.r_Count.docCount > 0) { this.availableAlphabets.push("R") }
    if (aggregation.s_Count.docCount > 0) { this.availableAlphabets.push("S") }
    if (aggregation.t_Count.docCount > 0) { this.availableAlphabets.push("T") }
    if (aggregation.u_Count.docCount > 0) { this.availableAlphabets.push("U") }
    if (aggregation.v_Count.docCount > 0) { this.availableAlphabets.push("V") }
    if (aggregation.w_Count.docCount > 0) { this.availableAlphabets.push("W") }
    if (aggregation.x_Count.docCount > 0) { this.availableAlphabets.push("X") }
    if (aggregation.y_Count.docCount > 0) { this.availableAlphabets.push("Y") }
    if (aggregation.z_Count.docCount > 0) { this.availableAlphabets.push("Z") }
    // if(aggregation.numeric_Count.docCount>0){this.availableAlphabets.push("0-9")}
    if (aggregation.number0_Count.docCount > 0 || aggregation.number1_Count.docCount > 0 || aggregation.number2_Count.docCount > 0 || aggregation.number3_Count.docCount > 0 || aggregation.number4_Count.docCount > 0 || aggregation.number5_Count.docCount > 0 || aggregation.number6_Count.docCount > 0 || aggregation.number7_Count.docCount > 0 || aggregation.number8_Count.docCount > 0 || aggregation.number9_Count.docCount > 0) { this.availableAlphabets.push("0-9") }
    return this.availableAlphabets;
  }

  goLetter(alphabet: string) {
    this.category = 0;


    this.CodPageCount = 0;
    this.OpPageCount = 0;
    this.CigPageCount = 0;
    this.selectedAlphabet = alphabet;
    this.invokeGlossaryContent();

    // if(glossaryType=="cod"){
    //   this.codSelectedAlphabet = alphabet;
    //   this.graphQlService.GetMasterGlossary(this.filter, this.codSelectedAlphabet,this.CodPageCount,"COD").subscribe(codRes=>{
    //       this.contacts = [];
    //       this.totalCodCount=codRes?.hits?.total?.value;
    //       this.codGlossaryContent = this.mapGlossaryContent(codRes?.hits?.hitsList,"glossary_codification");
    //       this.codGlossaryContentCount=codRes?.hits?.hitsList?.length;
    //       this.showNoCodResults=this.totalCodCount==0?true:false;
    //   });
    // }
    // else if(glossaryType=="op"){
    //   this.opSelectedAlphabet = alphabet;
    //   this.graphQlService.GetMasterGlossary(this.filter, this.opSelectedAlphabet,this.OpPageCount,"OP").subscribe(opRes=>{
    //     this.contacts=[];
    //     this.totalOpCount=opRes?.hits?.total?.value;
    //     this.opGlossaryContent = this.mapGlossaryContent(opRes?.hits?.hitsList,"glossary_op");
    //     this.opGlossaryContentCount=opRes?.hits?.hitsList?.length;
    //     this.showNoOpResults=this.totalOpCount==0?true:false;
    //   });
    // }
    // else{
    //   this.cigSelectedAlphabet = alphabet;
    //   this.graphQlService.GetMasterGlossary(this.filter, this.cigSelectedAlphabet,this.CigPageCount,"CIG").subscribe(cigRes=>{
    //     this.contacts = [];
    //     this.totalCigCount=cigRes?.hits?.total?.value;
    //     this.cigGlossaryContent = this.mapGlossaryContent(cigRes?.hits?.hitsList,"glossary_cig");
    //     this.cigGlossaryContentCount=cigRes?.hits?.hitsList?.length;
    //     this.showNoCigResults=this.totalCigCount==0?true:false;
    //   });
    // }

  }

  // IsSearchTermEmpty() {
  //   return this.filter == "" ? true : false;
  // }

  // IsSelectedAlphabet(alphabet: string){
  //   return this.selectedAlphabet == alphabet ? true : false;
  // }


  onChangeText(type?: string) {
    this.showNoCodResults = false;
    this.showNoOpResults = false;
    this.showNoCigResults = false;
    this.CodPageCount = 0;
    this.OpPageCount = 0;
    this.CigPageCount = 0;
    // this.invokeGlossaryContent();
    // if(this.filter=="" && this.selectedAlphabet==""){
    //   // this.resetSearchText();
    // }
    // else{
    this.invokeGlossaryContent();
    // }
  }

  createResultFromContact(passedContacts) {
    const grouped = passedContacts.reduce((groups, contact) => {
      if (contact.name.charCodeAt(0) >= 48 && contact.name.charCodeAt(0) <= 57) {
        groups["0-9"] = groups["0-9"] || [];
        groups["0-9"].push(contact);
      }
      else {
        const letter = contact.name.charAt(0).toLocaleUpperCase();
        groups[letter] = groups[letter] || [];
        groups[letter].push(contact);
      }
      return groups;
    }, {});
    return Object.keys(grouped).map(key => ({ key, contacts: grouped[key] }));
  }

  resetSearchText() {
    this.CodPageCount = 0;
    this.OpPageCount = 0;
    this.CigPageCount = 0;
    this.filter = "";
    this.selectedAlphabet = "";
    this.showNoCodResults = false;
    this.showNoOpResults = false;
    this.showNoCigResults = false;
    this.contacts = [];
    this.resultCount = 0;
    this.getAlphabetsList();
    this.invokeGlossaryContent(true);
  }

  findGlossary(evt, glossaryValue) {
    // this.filter = "";
    // this.selectedAlphabet = ""
    if (glossaryValue == "glossary_codification") {
      this.codification = true;
      this.originalPronouncements = false;
      this.comprehensiveImplementationGuide = false;
      // this.availableAlphabets = this.codGlossaryContent.map(a => a.key);
    }
    if (glossaryValue == "glossary_op") {
      this.originalPronouncements = true;
      this.codification = false;
      this.comprehensiveImplementationGuide = false;
      // this.availableAlphabets = this.opGlossaryContent.map(a => a.key);
    }
    if (glossaryValue == "glossary_cig") {
      this.comprehensiveImplementationGuide = true;
      this.originalPronouncements = false;
      this.codification = false;
      // this.availableAlphabets = this.cigGlossaryContent.map(a => a.key);
    }
    var tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("glossaryTabContent");
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    if (document.getElementById(glossaryValue) != null) {
      document.getElementById(glossaryValue).style.display = "block";
    }
    evt.currentTarget.className += " active";
    this.commonDataService.glossarytermbackbuttontabinformation.next({ evt: evt, glossval: glossaryValue});

  }

  ViewAll() {
    this.getAlphabetsList()
    this.invokeGlossaryContent(true);
  }
  ResetAlphabet(){
    this.selectedAlphabet="";
    this.invokeGlossaryContent();
  }

  // getData(glossaryType:string, event?: PageEvent) {
  //   if(glossaryType=="codification")
  //   {
  //     this.slicedCodContacts=this.codContacts.slice(event.pageIndex * event.pageSize,
  //       event.pageIndex * event.pageSize + event.pageSize);
  //   }
  //   else if(glossaryType=="originalPronouncements"){
  //     this.slicedOpContacts = this.opContacts.slice(event.pageIndex * event.pageSize,
  //       event.pageIndex * event.pageSize + event.pageSize);
  //   }
  //   else{
  //     this.slicedCigContacts = this.cigContacts.slice(event.pageIndex * event.pageSize,
  //       event.pageIndex * event.pageSize + event.pageSize);
  //   }
  //   return event;
  // }

  resultCount: number = 0;
  totalCodCount: number = 0;
  totalOpCount: number = 0;
  totalCigCount: number = 0;
  OpPageSize: any = 3;
  OpPageSizeOptions: number[] = [1, 2, 5, 10];

  CodPageSize: any = 3;
  CodPageSizeOptions: number[] = [1, 2, 5, 10];

  CigPageSize: any = 3;
  CigPageSizeOptions: number[] = [1, 2, 5, 10];
  pageEvent: PageEvent;
  slicedCodContacts: any = [];
  slicedCigContacts: any = [];
  slicedOpContacts: any = [];

  invokeGlossaryContent(viewAllData?: boolean) {
    this.codification = true;
    this.originalPronouncements = false;
    this.comprehensiveImplementationGuide = false;
    var tablinks = document.getElementsByClassName("tablinks");
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    if (tablinks.length != 0) {
      tablinks[0].className = tablinks[0].className + " active";
    }

    this.CodPageCount = 0;
    this.OpPageCount = 0;
    this.CigPageCount = 0;
    if (viewAllData) {
      this.filter = "";
      this.selectedAlphabet = "";
    }
    var isGlossaryTermFromBackButton = this.commonDataService.glossaryTerm.getValue();
    if (isGlossaryTermFromBackButton != "") {
      //this.filter = isGlossaryTermFromBackButton.split("<span")[0];
      this.filter = this.commonDataService.glossarytermfilterkey.getValue();
      this.selectedAlphabet = this.commonDataService.glossaryselectedAlphabet.getValue();
      this.commonDataService.glossaryTerm.next("");
      //this.selectedAlphabet = isGlossaryTermFromBackButton.substring(0, 1).toUpperCase();
      //if (Number(this.selectedAlphabet)) {
      //  this.selectedAlphabet = "0-9";
      //}
      
    }
    this.resultCount = 0;
    this.showNoCodResults = false;
    this.showNoOpResults = false;
    this.showNoCigResults = false;
    this.category = 0;
    if (this.filter != "") {
      this.graphQlService.GetMasterGLossaryAlphabetsfiltered(this.filter).subscribe(alphabetsList => { this.availableAlphabetsList = this.setAlphabetList(alphabetsList.aggregations); })
    }
    else {
      this.getAlphabetsList()
    }

    this.commonDataService.glossaryselectedAlphabet.next(this.selectedAlphabet);
    forkJoin([this.graphQlService.GetMasterGlossary(this.filter, this.selectedAlphabet, this.CodPageCount, "COD"), this.graphQlService.GetMasterGlossary(this.filter, this.selectedAlphabet, this.OpPageCount, "OP"), this.graphQlService.GetMasterGlossary(this.filter, this.selectedAlphabet, this.CigPageCount, "CIG")])
      .subscribe(([codRes, opRes, cigRes]) => {
      this.outcome = true;
      if (codRes) {
        this.commonDataService.glossarytermfilterkey.next(this.filter);
        this.contacts = [];
        // this.codContacts=[];
        this.totalCodCount = codRes?.hits?.total?.value;
        this.codGlossaryContent = this.mapGlossaryContent(codRes?.hits?.hitsList, "glossary_codification");
        this.codGlossaryContentCount = codRes?.hits?.hitsList?.length;
        this.showNoCodResults = this.totalCodCount == 0 ? true : false;
        // this.slicedCodContacts= this.codContacts.slice(0, this.CodPageSize);
      }
      if (opRes) {
        this.contacts = [];
        // this.opContacts=[];
        this.totalOpCount = opRes?.hits?.total?.value;
        this.opGlossaryContent = this.mapGlossaryContent(opRes?.hits?.hitsList, "glossary_op");
        this.opGlossaryContentCount = opRes?.hits?.hitsList?.length;
        this.showNoOpResults = this.totalOpCount == 0 ? true : false;
        // this.slicedOpContacts= this.opContacts.slice(0, this.OpPageSize);
      }
      if (cigRes) {
        this.contacts = [];
        // this.cigContacts=[];
        this.totalCigCount = cigRes?.hits?.total?.value;
        this.cigGlossaryContent = this.mapGlossaryContent(cigRes?.hits?.hitsList, "glossary_cig");
        this.cigGlossaryContentCount = cigRes?.hits?.hitsList?.length;
        this.showNoCigResults = this.totalCigCount == 0 ? true : false;
        // this.slicedCigContacts= this.cigContacts.slice(0, this.CigPageSize);
      }
      this.resultCount = this.codGlossaryContentCount + this.opGlossaryContentCount + this.cigGlossaryContentCount;

      if (this.codGlossaryContentCount > 0) {
        this.category++;
        if (viewAllData) {
          // this.availableAlphabets = this.codGlossaryContent.map(a => a.key);
        }
      }
      if (this.opGlossaryContentCount > 0) {
        this.category++;
      }
      if (this.cigGlossaryContentCount > 0) {
        this.category++;
      }
      if (this.resultCount == 0) {
        this.showNoCodResults = true;
        this.showNoOpResults = true;
        this.showNoCigResults = true;
      }
      if (isGlossaryTermFromBackButton != "") {
        var tabvalue = this.commonDataService.glossarytermbackbuttontabinformation.getValue()
        if (tabvalue != "") {
          var selectedval = tabvalue.glossval;
          this.codification = selectedval == "glossary_codification";
          this.originalPronouncements = selectedval == "glossary_op";
          this.comprehensiveImplementationGuide = selectedval == "glossary_cig";
          
          tablinks = document.getElementsByClassName("tablinks");
          for (let i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
          }
          if (tablinks.length != 0) {
            if (this.codification) tablinks[0].className = tablinks[0].className + " active";
            else if (this.originalPronouncements) tablinks[1].className = tablinks[1].className + " active";
            else if (this.comprehensiveImplementationGuide) tablinks[2].className = tablinks[2].className + " active";
          }
        }
      }
    })
    

  }
  getAllTabsGlossaryData(viewAllData) {
    forkJoin([this.graphQlService.GetMasterGlossary(this.filter, this.selectedAlphabet, this.CodPageCount, "COD"), this.graphQlService.GetMasterGlossary(this.filter, this.selectedAlphabet, this.OpPageCount, "OP"), this.graphQlService.GetMasterGlossary(this.filter, this.selectedAlphabet, this.CigPageCount, "CIG")]).subscribe(([codRes, opRes, cigRes]) => {
      this.outcome = true;
      if (codRes) {
        this.contacts = [];
        // this.codContacts=[];
        this.totalCodCount = codRes?.hits?.total?.value;
        this.codGlossaryContent = this.mapGlossaryContent(codRes?.hits?.hitsList, "glossary_codification");
        this.codGlossaryContentCount = codRes?.hits?.hitsList?.length;
        this.showNoCodResults = this.totalCodCount == 0 ? true : false;
        // this.slicedCodContacts= this.codContacts.slice(0, this.CodPageSize);
      }
      if (opRes) {
        this.contacts = [];
        // this.opContacts=[];
        this.totalOpCount = opRes?.hits?.total?.value;
        this.opGlossaryContent = this.mapGlossaryContent(opRes?.hits?.hitsList, "glossary_op");
        this.opGlossaryContentCount = opRes?.hits?.hitsList?.length;
        this.showNoOpResults = this.totalOpCount == 0 ? true : false;
        // this.slicedOpContacts= this.opContacts.slice(0, this.OpPageSize);
      }
      if (cigRes) {
        this.contacts = [];
        // this.cigContacts=[];
        this.totalCigCount = cigRes?.hits?.total?.value;
        this.cigGlossaryContent = this.mapGlossaryContent(cigRes?.hits?.hitsList, "glossary_cig");
        this.cigGlossaryContentCount = cigRes?.hits?.hitsList?.length;
        this.showNoCigResults = this.totalCigCount == 0 ? true : false;
        // this.slicedCigContacts= this.cigContacts.slice(0, this.CigPageSize);
      }
      this.resultCount = this.codGlossaryContentCount + this.opGlossaryContentCount + this.cigGlossaryContentCount;

      if (this.codGlossaryContentCount > 0) {
        this.category++;
        if (viewAllData) {
          // this.availableAlphabets = this.codGlossaryContent.map(a => a.key);
        }
      }
      if (this.opGlossaryContentCount > 0) {
        this.category++;
      }
      if (this.cigGlossaryContentCount > 0) {
        this.category++;
      }
      if (this.resultCount == 0) {
        this.showNoCodResults = true;
        this.showNoOpResults = true;
        this.showNoCigResults = true;
      }
    })
  }

  loadNextPage(glossaryType: string) {
    if (glossaryType == 'glossary_codification') {
      this.CodPageCount = this.CodPageCount + 1;
      this.getGlossaryContent(glossaryType, this.CodPageCount);
    }
    else if (glossaryType == 'glossary_op') {
      this.OpPageCount = this.OpPageCount + 1;
      this.getGlossaryContent(glossaryType, this.OpPageCount);
    }
    else {
      this.CigPageCount = this.CigPageCount + 1;
      this.getGlossaryContent(glossaryType, this.CigPageCount);
    }
  }

  getGlossaryContent(glossaryType: string, pagecount: number) {
    var Type;
    var selectedAlphabet = "";
    if (glossaryType == 'glossary_codification') {
      Type = "COD";
      selectedAlphabet = this.selectedAlphabet;
    }
    else if (glossaryType == 'glossary_op') {
      Type = "OP";
      selectedAlphabet = this.selectedAlphabet;
    }
    else {
      Type = "CIG";
      selectedAlphabet = this.selectedAlphabet;
    }
    this.graphQlService.GetMasterGlossary(this.filter, selectedAlphabet, pagecount, Type).subscribe(res => {
      if (res) {
        this.contacts = [];
        this.mapGlossaryContent(res?.hits?.hitsList, glossaryType);
        // if (glossaryType == 'glossary_codification') {
        //   this.availableAlphabets = this.codGlossaryContent.map(a => a.key);
        // }
        // else if (glossaryType == 'glossary_op') {
        //   this.availableAlphabets = this.opGlossaryContent.map(a => a.key);
        // }
        // else {
        //   this.availableAlphabets = this.cigGlossaryContent.map(a => a.key);
        // }
      }
    })
  }

  setFocus() {
    document.getElementById("scrollList").scroll(0, 0);
  }

  enableBackToTop: boolean = false;

  EnableBackToTop() {

    var div = document.getElementById("scrollList");
    if (div != null) {
      var hasVerticalScrollbar = div.scrollHeight > div.clientHeight;

      if (hasVerticalScrollbar) {
        this.enableBackToTop = true;
      }
      else {
        this.enableBackToTop = false;
      }
    }
  }

  OpenLink(event, glossaryTitle: string) {
    const path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    const xref = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    const term = event.target.className.includes("term");
    const diamondLinkChanged = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className.includes("diamond_link"));
    const diamondLink = event.target.childNodes[0] == undefined ? false : (event.target.childNodes[0].className == undefined ? false : event.target.childNodes[0].className.includes("xref diamond_link"));
    if (diamondLinkChanged) {
      let href = diamondLinkChanged.getAttribute('href');
      let otherSourceUrlParts = href?.split("/");
      let publicationId = otherSourceUrlParts[1];
      let pageId = otherSourceUrlParts[2];
      let footnoteId = href?.includes('#') ? href?.split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      window.open(location.origin + "/" + publicationId + "/" + pageId + "/" + footnoteId, '_blank').focus();
    }
    else if (diamondLink) {
      let href = event.target.childNodes[0].href;
      let urlParts = href.split("/");
      let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
      let url = "/" + urlParts[3] + "/" + urlParts[4] + "/" + urlLastPart;
      window.open(url);
    }
    else if (xref) {
      let href = xref.getAttribute("href");
      if (href.includes("http")) {
        window.open(href);
      }
      else {
        this.commonDataService.glossaryTermFromContentPageBackButton.next(glossaryTitle);
        let urlParts = href.split("/");
        let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
        let url = "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart;
        //this.route.navigateByUrl(url);
        window.open(url);
      }

      // this.route.navigateByUrl("/1852827/1830712")
    }
    else if (term) {
      let id = event.target.id;

      event.preventDefault();
      id = id == "" && term != null && term != undefined ? event.target.parentNode.id : id;

      this.commonDataService.rightOverlayOption.next("inline-glossary");
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.glossaryTermId.next(id);
      this.commonDataService.showRightPanel.next(true);
    }
    else if (path.find(p => p.tagName && p.tagName.toLowerCase() === 'a')) {
      let href = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a').getAttribute("href");
      this.commonDataService.glossaryTermFromContentPageBackButton.next(glossaryTitle);
      let urlParts = href.split("/");
      let urlLastPart = href.includes('#') ? href.split('#')[1] : urlParts[urlParts.length - 1];
      let url = "/" + urlParts[1] + "/" + urlParts[2] + "/" + urlLastPart;
      //this.route.navigateByUrl(url);
      window.open(url);
    }

  }

  onRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a") {
      let href = event.target.getAttribute('href').split("/");
      let urlLastPart = href.includes('#') ? href.split('#')[1] : href[href.length - 1];
      if (href.length != 0) {
        event.srcElement.setAttribute("href", "/" + href[1] + "/" + href[2] + "/" + urlLastPart);
      }

    }
  }

  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a") {
      let href = event.target.getAttribute('href').split("/");
      let urlLastPart = href.includes('#') ? href.split('#')[1] : href[href.length - 1];
      if (href.length == 0) {
        event.srcElement.setAttribute("href", "/" + href[1] + "/" + href[2] + "/" + urlLastPart);
      }
    }
  }
}
